// extracted by mini-css-extract-plugin
module.exports = {"splash":"index_splash__1a4dk","inner":"index_inner__pP70a","error":"index_error__3EFQL"};